module.exports = __webpack_public_path__ + "c53c142cf9219871ab887ceed2ff11b2.png";